import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import { gridSpacing } from 'store/constant';

import SliderFilter from './SliderFilter'
import AutocompleteFilter from './AutocompleteFilter';
import { AdvFilterV2Context, FilterIcon } from '../filterContext';

import { getLanguages } from 'api_handlers/influencer';
import { getDeliverables } from 'api_handlers/brand';
import { getCityStateList } from 'api_handlers/discovery';

import { updateFilters } from 'actions/planner-filters';

const InfluencerFilters = () => {
  const dispatch = useDispatch();
  const v2 = useContext(AdvFilterV2Context);
  const engagementRate = useSelector(state => state.plannerFilters.engagementRate);
  const engagedUsers = useSelector(state => state.plannerFilters.engagedUsers);
  const views = useSelector(state => state.plannerFilters.views);
  const ageGroup = useSelector(state => state.plannerFilters.ageGroup);
  const country = useSelector(state => state.plannerFilters.country || []);
  const stateFilter = useSelector(s => s.plannerFilters.state || []);
  const cityFilter = useSelector(s => s.plannerFilters.city || []);
  const region = useSelector(state => state.plannerFilters.region || []);
  const language = useSelector(state => state.plannerFilters.language || []);
  const deliverables = useSelector(state => state.plannerFilters.deliverables || []);

  const [languageOptions, setLocationOptions] = React.useState([]);
  const [deliverableOptions, setDeliverableOptions] = React.useState([]);
  const [countryOptions, setCountryOptions] = React.useState([]);
  const [stateOptions, setStateOptions] = React.useState([]);
  const [cityOptions, setCityOptions] = React.useState([]);

  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => {
    const langs = await getLanguages();
    setLocationOptions([...langs.map((language) => language.name)]);

    const deliverableResponse = await getDeliverables()
    setDeliverableOptions([...deliverableResponse.data.map((deliverable) => deliverable.name)]);

    const countryResponse = await getCityStateList('country');
    const countries = [...countryResponse.data.filter(option => option)];
    setCountryOptions(countries);

    const stateResponse = await getCityStateList('state');
    const states = stateResponse.data.filter(option => option);
    setStateOptions(states);

    const stateSet = new Set(states.map(s => s.toLowerCase()));
    const cityResponse = await getCityStateList('city');
    setCityOptions(cityResponse.data.filter(option => option && !stateSet.has(option.toLowerCase())));



  }, [])

  return (
    <Grid container spacing={gridSpacing} sx={{height: 300, overflowY: 'scroll', pl: 4, pr: 2}}>
      <Grid item xs={12}>
       <Box className={v2 ? 'dv2-group-box' : undefined}>
        {v2 && <Typography className="dv2-group-label">Performance</Typography>}
        <SliderFilter value={engagementRate !== undefined ? engagementRate : ''} title='Engagement Rate'  min={0} max={100} stepSize={0.1} payloadKey={'engagementRate'} showTextField={true} />
        <SliderFilter value={engagedUsers || 0} title='Average Engaged Users' min={0} max={1000000} payloadKey={'engagedUsers'} showTextField={true} />
        <SliderFilter value={views || 0} title='Average Views' min={0} max={10000000} payloadKey={'views'} showTextField={true} />
       </Box>
      </Grid>
      {/* Targeting group */}
      <Grid item xs={12}>
       <Box className={v2 ? 'dv2-group-box' : undefined}>
        {v2 && <Typography className="dv2-group-label">Targeting</Typography>}
        <Grid container spacing={2} alignItems='center' justifyContent='space-evenly' sx={{ mb: 2 }}>
          <Grid item xs={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              {v2 && <FilterIcon title="Age Group" />}
              Age Group
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Select
              labelId="ageGroup-select"
              id="ageGroup"
              name="ageGroup"
              value={ageGroup || (v2 ? '' : ageGroup)}
              displayEmpty={v2}
              renderValue={v2 ? (sel) => (sel ? sel : <span style={{ color: '#9aa1b2' }}>Select age group</span>) : undefined}
              onChange={(event) => {
                dispatch(updateFilters('ageGroup', event.target.value))
              }}
              label="Age Group"
              fullWidth
              size='small'
            >
              <MenuItem value={'13-17'}>13 - 17</MenuItem>
              <MenuItem value={'18-24'}>18 - 24</MenuItem>
              <MenuItem value={'25-34'}>25 - 34</MenuItem>
              <MenuItem value={'35-44'}>35 - 44</MenuItem>
              <MenuItem value={'45-64'}>45 - 64</MenuItem>
              <MenuItem value={'65-'}>65 - </MenuItem>
            </Select>
          </Grid>
        </Grid>
        <AutocompleteFilter options={languageOptions} title='Language' payloadKey={'language'} value={language} />
        <AutocompleteFilter options={deliverableOptions} title='Deliverables' payloadKey={'deliverables'} value={deliverables} />
        <AutocompleteFilter options={countryOptions} title='Country' payloadKey={'country'} value={country} />
        <AutocompleteFilter options={stateOptions} title='State' payloadKey={'state'} value={stateFilter} />
        <AutocompleteFilter options={cityOptions} title='City' payloadKey={'city'} value={cityFilter} />
        <AutocompleteFilter options={['North', 'East', 'West', 'South']} title='Region' payloadKey={'region'} value={region} />
       </Box>
      </Grid>

    </Grid>
  )
}

export default InfluencerFilters;